// removed by extract-text-webpack-plugin
module.exports = {"ShareSection":"SaveShareCopy__ShareSection___2r2ab","ShareSectionDisabled":"SaveShareCopy__ShareSectionDisabled___1EhpY","ShareSectionColumn":"SaveShareCopy__ShareSectionColumn___1z8_D","ShareSectionText":"SaveShareCopy__ShareSectionText___1C8sY"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/SaveShareCopy/SaveShareCopy.less
// module id = 1205
// module chunks = 0 1